import Box from 'atomic/box';
import classNames from 'classnames';
import React from 'react';
import Icon from '../../../../../views/atomic/icon/icon';
import Tooltip from '../../../../../views/atomic/tooltip/tooltip';
import './product-section-box.scss';

interface ProductSectionBoxProps {
    headerText?: string;
    className?: string;
    text?: string;
    secondText?: string;
    padding?: 'none' | 'sm' | 'md' | 'lg';
    boxView?: boolean;
    tooltipInfo?: {
        icon?: string;
        title: string;
        description: string;
    } | null;
    children: React.ReactNode;
}

const ProductSectionBox: React.FC<ProductSectionBoxProps> = ({
    headerText,
    text,
    children,
    padding = 'md',
    secondText,
    boxView,
    tooltipInfo,
    className
}) => (
    <Box
        className={classNames('product-section-box', className)}
        padding={padding}
    >
        {headerText && <h2 className="product-section-box__header">
            {headerText}
            {tooltipInfo && <Tooltip
                positions={['top']}
                trigger={<span className="product-section-box__header-tooltip">
                    <Icon
                        className="icon-info"
                        name={tooltipInfo?.icon ?? 'info'}
                        color="primary"
                        title={tooltipInfo?.title}
                        size={20}
                        tabIndex={0}
                        aria-label="Otwórz info"
                        role="button"
                    />
                </span>}
                title={<>
                    {tooltipInfo?.title}
                </>}
            >
                <p className="tooltip-text">
                    {tooltipInfo?.description}
                </p>
            </Tooltip>}
        </h2>}
        {text && (
            <p className="product-section-box__text">
                {text}
            </p>
        )}
        <div className={classNames({
            'product-section-box__main': true,
            'product-section-box__main--title': headerText || text,
            'product-setion-box__main--box-view': Boolean(boxView)
        })}
        >
            {secondText && (
                <div className="product-section-box__second-text">
                    {secondText}
                </div>
            )
            }
            {children}
        </div>
    </Box>
);

export default ProductSectionBox;
